import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { Observable, of } from 'rxjs';
import { IInitialPageData } from '../shared/interface/general';
import get from 'lodash.get';

export interface INavigationItem {
  title: string;
  url: string;
  isActive?: boolean;
}

export interface ILanguageItem {
  isoCode: any;
  url: string;
  image: any;
  isActive: boolean;
}

export interface IHeaderItem {
  phone: string;
  languageName: string;
  contactPage: any;
  demoPage: any;
  buyPage: any;
  loginPage: any;
  logo: any;

  topBackgroundColor: string;
  topTextColor: string;
  bottomBackgroundColor: string;
  bottomTextColor: string;
}

export interface IFooterItem {
  header?: string;
  items?: any[];
  googlePlayPage: any;
  appleStorePage: any;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  initialPageData: IInitialPageData | null = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);

  constructor(
    private http: HttpClient
  ) { }

  getTopNavigation(): Observable<INavigationItem[]>
  {
    if (this.initialPageData && this.initialPageData.topNavigation) {
      return of(this.initialPageData.topNavigation);
    }

    return this.http.get<INavigationItem[]>(`${config.api}/bgnavigation/getTopNavigation`);
  }

  getLanguage(): Observable<{ languages: ILanguageItem[] }>
  {
    return this.http.get<{ languages: ILanguageItem[] }>(`ubaseline/api/siteSettings/get/endpoint`);
  }

  getHeaderNavigation(): Observable<IHeaderItem>
  {
    if (this.initialPageData && this.initialPageData.headerNavigation) {
      return of(this.initialPageData.headerNavigation);
    }

    return this.http.get<IHeaderItem>(`/ubaseline/api/bgnavigation/getHeaderNavigation`);
  }

  getFooterNavigation(): Observable<IFooterItem>
  {
    if (this.initialPageData && this.initialPageData.footerNavigation) {
      return of(this.initialPageData.footerNavigation);
    }

    return this.http.get<IFooterItem>(`/ubaseline/api/bgnavigation/getFooterNavigation`);
  }
}
